import { clearToken, setError, setLoading } from 'state/reducers/auth.reducers';
import { clearUser, setUserPermissions } from 'state/reducers/user.reducers';
import { apiFunctionsEnum } from 'constants/api.constants';
import ApiService from './api.service';

export function getMyPermissions() {
	return async (dispatch: any) => {
		dispatch(setLoading(true));
		dispatch(setError(null));
		await ApiService.getInstance()
			.execute(apiFunctionsEnum.GET_MY_PERMISSIONS)
			.then((response: any) => {
				dispatch(setUserPermissions(response.data.permissions));
			})
			.catch((error: any) => {})
			.finally(() => {
				dispatch(setLoading(false));
			});
	};
}

export function logOut() {
	return (dispatch: any) => {
		dispatch(clearToken());
		dispatch(clearUser());
		dispatch(setError(null));
	};
}
